export default () => {
  const ankerlink = document.getElementById('js-anker');
  if (!ankerlink) return;
  ankerlink.addEventListener('click', function(event) {
    linkscroll('#form');
  });

  function linkscroll(target) {
    document.querySelector(target).scrollIntoView({ behavior: 'smooth' });
  }
  const  agreeCheck = document.getElementById('js-agreeCheck');
  if (!agreeCheck) return;

    agreeCheck.addEventListener('change', () => {
      document.querySelectorAll('input#js-agreeCheck').forEach(agreeInput => {
        const submitBtn = agreeInput.closest('form')?.querySelector('button.btn_confirm');
        if (!submitBtn) return;
        if (agreeInput.checked) {
          submitBtn.style.pointerEvents = 'auto';
          submitBtn.style.opacity = '1';
          submitBtn.disabled = false;
        } else {
          submitBtn.style.pointerEvents = 'none';
          submitBtn.style.opacity = '0.8';
          submitBtn.disabled = true;
        }
      });
    });


}
